import React, { lazy, Suspense } from 'react';
const AudienceContent = lazy(() => import('./InfluencerContent'));

export default function PreviewAudienceContent({ ClassicContent, ...props }) {
  const sharedProduct = ['async', 'paidDMs', 'community', 'sign_up', 'urls'].includes(props.selected_tab);
  if (props.previewRolloutOwner === true && props.isLoggedOutView === true && sharedProduct) {
    return <Suspense fallback={null}><AudienceContent {...props} /></Suspense>;
  }
  return <ClassicContent {...props} />;
}
